<template>
  <v-footer
    fixed
    color="white"
  >
    <div style="position: relative;width: 100%;">
      <v-row>
        <div class="flex-grow-1" />

        <v-col class="text-right">
          <div
            style="font-size: 14px"
          >
            <strong>Copyright © {{ new Date().getFullYear() }} DXE INC.</strong>
          </div>
        </v-col>
        <v-chip
          class="ma-2"
          small
        >
          Ver.{{ version }}
        </v-chip>
      </v-row>
    </div>
  </v-footer>
</template>

<script>

/**
 * セッション用フッター
 */
export default {
  name: 'FooterNav',
  data() {
    return {
      version: require('../../../package.json').version
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  },
}

</script>

<style scoped lang="scss">
</style>
